import { Label, Field } from "@headlessui/react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { handleEnterKey } from "../../app/keyboardUtils";

interface SearchFilterProps {
	searchFilter: string;
	setSearchFilter: (value: string) => void;
	id: string;
	name: string;
	maxLength?: number;
	label?: string;
	placeHolder?: string;
	className?: string;
	htmlFor?: string;
	actionButton?: ActionButton;
	hiddenLabel?: boolean;
}

interface ActionButton {
	label: string;
	onClick: () => void;
}

export default function SearchFilter(props: SearchFilterProps) {
	const getClassName = (classes?: string) => {
		if (classes != undefined && classes.trim().length > 1) return classes;
		return undefined;
	};

	const handleClear = () => {
		props.setSearchFilter("");
	};

	return (
		<Field className={getClassName(props.className)}>
			{props.hiddenLabel ? (
				<label htmlFor={props.htmlFor ?? ""} className="sr-only">
					{props.label}
				</label>
			) : (
				<Label htmlFor={props.htmlFor ?? ""} className="block mb-2 text-sm font-medium">
					{props.label ?? "Search"}
				</Label>
			)}
			<div className={"flex rounded-md shadow-sm h-9"}>
				<div className="relative flex grow items-stretch focus-within:z-10">
					<div className="pointer-events-none absolute left-3 top-2">
						<MagnifyingGlassIcon aria-hidden="true" className="size-5 text-gray-400" />
					</div>
					<input
						id={props.id}
						name={props.name}
						placeholder={props.placeHolder ?? "Search"}
						value={props.searchFilter}
						maxLength={props.maxLength ?? undefined}
						className={`${props.actionButton ? "rounded-none rounded-l-md" : "rounded-md"} block w-full border-1 border-gray-300 py-2 px-10 text-sm`}
						onChange={(e) => props.setSearchFilter(e.target.value)}
					/>
					{props.searchFilter && (
						<div
							tabIndex={0}
							className="hover:cursor-pointer absolute right-3 top-2"
							onClick={() => handleClear()}
							onKeyDown={(e) => handleEnterKey(e, handleClear)}>
							<XMarkIcon aria-hidden="true" className="size-5 text-gray-400" />
						</div>
					)}
				</div>
				{props.actionButton && (
					<button
						type="button"
						onClick={props.actionButton.onClick}
						className="relative border border-gray-300 inline-flex items-center rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
						{props.actionButton.label}
					</button>
				)}
			</div>
		</Field>
	);
}
